import { Component, Input, OnInit } from '@angular/core';
import { IColumn, ITableOptions } from '@modeso/aumico-lib-core-fe';
import { INotesTemplateDTO } from '@modeso/types__aumico-lib-notes-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import Debug from 'debug';
import { Observable, Subscription } from 'rxjs';
import { INotesTemplatesTableData } from '../../../interfaces/INotesTemplatesTableData.interface';
import { NotesTemplateMapper } from '../../../mappers/notesTemplates.mapper';
import { NotesProvider } from '../../../provider/notes.provider';
import { INotesTemplatesListDelegate } from './INotesTemplatesListDelegate.interface';

const debug = Debug('aumico:aumico-lib-notes-fe:NotesTemplatesListPage');

@UntilDestroy()
@Component({
    selector: 'aumico-notes-templates-list-page',
    templateUrl: 'notes-templates-list.page.html',
    styleUrls: ['notes-templates-list.page.scss'],
})
export class NotesTemplatesListPage implements OnInit {
    @Input() public set injectedProviderSetter(injectedProvider: NotesProvider) {
        if (injectedProvider) {
            this.provider = injectedProvider;
        }
    }

    @Input() language = 'de-ch';

    DELEGATE?: INotesTemplatesListDelegate;
    @Input() public set delegate(delegate: INotesTemplatesListDelegate) {
        if (delegate) {
            this.DELEGATE = delegate;
        }
    }

    protected subscriptions: Subscription[] = [];
    errorMessage: Observable<string>;
    columns: IColumn[];
    tableOptions: ITableOptions;
    data: INotesTemplatesTableData[];
    isBackendReturnError = false;
    backendErrors: string;

    constructor(private provider: NotesProvider, private notesTemplatesMapper: NotesTemplateMapper) {
        this.prepareTableColumns();
    }

    ngOnInit(): void {
        this.provider.dispatchNotesTemplates();
        this.provider
            .getNotesTemplates$()
            .pipe(untilDestroyed(this))
            .subscribe(this.handleGetNotesTemplates.bind(this));
    }

    handleGetNotesTemplates(notesTemplates: INotesTemplateDTO[]) {
        if (notesTemplates) {
            this.data = this.notesTemplatesMapper.prepareNotesTemplateListData(notesTemplates);
            debug('ngOnInit getNotesTemplates result');
            debug(notesTemplates);
        }
    }

    onRowButtonClicked(id: string, action?: string): void {
        debug(`1 Row with Id ${id} clicked for action ${action}`);
        this.provider.selectActiveNotesTemplate(id);
        this.DELEGATE.onAddOrUpdateNotesTemplateClicked();
    }

    onAddNewNotesType(): void {
        this.DELEGATE.onAddOrUpdateNotesTemplateClicked();
    }

    prepareTableColumns() {
        this.columns = [
            { name: 'name', type: 'text', property: 'name' },
            { name: 'account basis', type: 'text', property: 'accountBasis' },
            { name: 'legal form', type: 'text', property: 'legalForm' },
            { name: 'edit', type: 'button', property: '_id', action: 'edit' },
        ];

        this.tableOptions = { columns: this.columns };
    }
}
